var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSupplementalIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 6,
    viewBox: "0 0 25 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3L5 .113v5.774L0 3zm1.042-.5a.5.5 0 010 1v-1zm2.083 1a.5.5 0 010-1v1zm2.083-1a.5.5 0 110 1v-1zm2.084 1a.5.5 0 110-1v1zm2.083-1a.5.5 0 110 1v-1zm2.083 1a.5.5 0 010-1v1zm2.084-1a.5.5 0 010 1v-1zm2.083 1a.5.5 0 010-1v1zm2.083-1a.5.5 0 110 1v-1zm2.084 1a.5.5 0 110-1v1zm2.083-1a.5.5 0 010 1v-1zm2.083 1a.5.5 0 010-1v1zm-20.833-1h2.083v1H3.125v-1zm4.167 0h2.083v1H7.292v-1zm4.166 0h2.084v1h-2.084v-1zm4.167 0h2.083v1h-2.083v-1zm4.167 0h2.083v1h-2.083v-1zm4.166 0H25v1h-1.042v-1z",
    fill: "#FFBF00"
  })));
}
export default SvgArrowSupplementalIc;